import { Inject, Injectable, InjectionToken, Optional } from '@angular/core'
import { environment } from '../../environments/environment'
import { environmentFactory } from '../../environments/factory'

export const ENVIRONMENT_CONFIG = new InjectionToken<any>('ENVIRONMENT_CONFIG')

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    environment: any = {}

    constructor(@Optional() @Inject(ENVIRONMENT_CONFIG) environmentConfig: any) {
        let globalEnvironment: any = {}

        // try and get settings from the global environment
        try {
            globalEnvironment = (<any>window).mistergreen.environment || {}
        } catch {}

        this.environment = environmentFactory(environment, environmentConfig || globalEnvironment)
    }

    get hostDomain(): string {
        return (this.environment?.host || 'mistergreen.nl').split('.').splice(-2).join('.')
    }
}
